import i18next from 'i18next';
import i18nextBrowserLanguagedetector from 'i18next-browser-languagedetector';
import jQuery from 'jquery';
import mapi from './mapi.js';
import I18NextVue from 'i18next-vue';
import jin from './locale.js';
import jqueryI18next from 'jquery-i18next';
import ChainedBackend from "i18next-chained-backend";
import HttpBackend from "i18next-http-backend";
import LocalStorageBackend from "i18next-localstorage-backend";

var caches = {};
class i18n {
    constructor(opts) {
        this.opts = opts;
        this.el = "";
        this.dom = "";
        this.applyed = false;
    }

    async init() {
        let opts = this.opts;

        let key = opts.key;
        this.key = key;
        let cfg = null;
        try {
            cfg = JSON.parse(localStorage.getItem("xi18n_" + key));
        } catch (e) {
            cfg = null;
        }

        // 取得 hash
        if (cfg == null || cfg['expire'] < new Date().getTime()) {
            let ret = await mapi.queryV2({
                method: "get",
                path: "locale/" + key
            });
            cfg = ret;
            cfg['expire'] = new Date().getTime() + 1 * 60 * 60 * 1000;
            localStorage.setItem("xi18n_" + key, JSON.stringify(cfg));
        }
        let hash = cfg['data']['hash'];


        opts = $.extend({
            debug: false,
            fallbackLng: 'en',
            lowerCaseLng: true,

            backend: {
                backends: [
                    LocalStorageBackend,
                    HttpBackend
                ],
                backendOptions: [{
                    prefix: 'i18next_res_' + key,
                    defaultVersion: hash,
                    expirationTime: 1 * 24 * 60 * 60 * 1000 // 7 days
                }, {
                    //                    loadPath: mapi.wapi_url + '/v2/locale/' + opts.key + '/{lng}/' + hash,
                    loadPath: "https://d12ayi4fy6naqd.cloudfront.net/" + opts.key + '/{lng}/' + hash,
                }]
            },
            supportedLngs: cfg['data']['lngs'],
            interpolation: {
                prefix: "{",
                suffix: "}"
            }
        }, opts);

        let t = i18next.createInstance();

        t.use(i18nextBrowserLanguagedetector)
            .use(ChainedBackend)
            .init(opts, (err, t) => {
                if (err) {
                    mapi.alert(err);
                } else {
                    this.opts.oninit(t);
                }
            });

        this.i18next = t;

        this.dom = jin.init(t, jQuery, {
            selectorAttr: 'data-i18n', // selector for translating elements
            targetAttr: 'i18n-target', // data-() attribute to grab target element to translate (if different than itself)
            optionsAttr: 'i18n-options', // data-() attribute that contains options, will load/set if useOptionsAttr = true
            useOptionsAttr: false, // see optionsAttr
            parseDefaultValueFromContent: true // parses default values from content ele.val or ele.text
        });
    }

    getI18n() {
        return this.i18next;
    }

    getI18nVue() {
        return I18NextVue;
    }

    applyToJquery() {
        this.applyed = true;
        jqueryI18next.init(this.i18next, jQuery, { useOptionsAttr: true });

    }

    applyElement(el) {
        this.el = el;
    }

    update() {
        if (this.el == "") {
            return;
        }
        this.dom.handle(this.el);
        if (typeof this.opts.onchange == 'function') {
            this.opts.onchange(this.lang);
        }
        if (this.applyed) {
            this.el.localize();
        }
    }

    t(key) {
        return this.i18next.t(key);
    }

    get lang() {
        return this.i18next.language;
    }

    set lang(v) {
        this.i18next.changeLanguage(v, () => { this.update(); });
    }
}


async function getI18n(opts) {
    if (caches[opts.key] != undefined) {
        console.log("get i18n from cache");
        return caches[opts.key];
    }
    let key = opts.key;

    let t = new i18n(opts);
    await t.init();

    caches[key] = t;
    return t;
}

export { getI18n };